// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 11) return "static/js/5684c16002f6e16d8a76.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"8a574fb0650d36d42561","180":"5a47398edde3c3cd7288","181":"fbaf4d53f0f1a1208f7a"}[chunkId] + ".chunk.js";
};